import React, {ReactElement, FocusEventHandler} from 'react';
import {Typography} from '@customink/pigment-react';
import './index.scss';

type Props = {
  min?: number;
  max?: number;
  readOnly?: boolean;
  value: number;
  onChange?: (value: number) => void;
};

const changeQty = (value: number, onChange: (value: number) => void) => {
  onChange(value);
};

const QuantityStepper = ({
  min = 1,
  max = 99999,
  readOnly = true,
  value,
  onChange
}: Props): ReactElement => {
  const disabledDecrement = value <= min;
  const disabledIncrement = value >= max;
  const disabledDecrementClass = disabledDecrement
    ? 'storesStepper-button--disabled'
    : '';
  const disabledIncrementClass = disabledIncrement
    ? 'storesStepper-button--disabled'
    : '';
  const handleFocus: FocusEventHandler<HTMLInputElement> = e => {
    if (!readOnly) e.target.select();
  };

  return (
    <div>
      <Typography className="storesStepper-label" variant="bodyLong2">
        Quantity
      </Typography>
      <div className="storesStepper">
        <span
          className={`storesStepper-button storesStepper-decrement ${disabledDecrementClass}`}
          onClick={() => !disabledDecrement && changeQty(value - 1, onChange)}
          onKeyDown={e => {
            if (e.key === 'Enter' && !disabledDecrement)
              changeQty(value - 1, onChange);
          }}
          role="button"
          tabIndex={0}>
          −
        </span>

        <input
          className="storesStepper-input"
          value={value}
          min={min}
          max={max}
          type="number"
          readOnly={readOnly}
          onChange={e => changeQty(parseInt(e.target.value, 10), onChange)}
          onFocus={handleFocus}
        />

        <span
          className={`storesStepper-button storesStepper-increment ${disabledIncrementClass}`}
          onClick={() => !disabledIncrement && changeQty(value + 1, onChange)}
          onKeyDown={e => {
            if (e.key === 'Enter' && !disabledIncrement)
              changeQty(value + 1, onChange);
          }}
          role="button"
          tabIndex={0}>
          +
        </span>
      </div>
    </div>
  );
};

QuantityStepper.defaultProps = {
  min: 1,
  max: 99999,
  readOnly: true,
  onChange: (): null => null
};

export default QuantityStepper;
